export default __webpack_public_path__ + "static/media/VIT-logo.8ad695b7.svg";